import { ArticleSetDetailsDTOArticleTypeEnum, RoofDTOPreferredProductEnum } from '@solel/esdec';

export const EsdecApiKeys = {
  getSurfaces: ['esdecGetSurfaces'],
  esdecArticles: (
    preferredProduct: RoofDTOPreferredProductEnum,
    articleType: ArticleSetDetailsDTOArticleTypeEnum
  ) => ['esdecArticles', preferredProduct, articleType]
};
